import { render, staticRenderFns } from "./join_visit.vue?vue&type=template&id=0e7fb47a&scoped=true&"
import script from "./join_visit.vue?vue&type=script&lang=js&"
export * from "./join_visit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7fb47a",
  null
  
)

export default component.exports